module.exports = __webpack_public_path__ + "static/media/3@3x.5e8977c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/3@3x.png
// module id = 756
// module chunks = 0